import { Mail, Phone } from 'lucide-react';

const ContactInfo = ({ icon: Icon, title, value, subtitle }) => (
  <div className="flex items-start gap-4 p-6 bg-white rounded-xl border border-gray-100 shadow-lg h-full">
    <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0 text-helix-blue">
      <Icon className="w-6 h-6" />
    </div>
    <div>
      <h4 className="font-semibold text-gray-900">{title}</h4>
      <p className="text-gray-800 font-medium text-lg">{value}</p>
      <p className="text-gray-500 text-sm">{subtitle}</p>
    </div>
  </div>
);

const Contact = () => {
  return (
    <section data-testid="contact-section" id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column - Info */}
          <div>
            <span className="text-xs tracking-[0.2em] uppercase text-helix-orange font-medium mb-4 block">
              Get in Touch
            </span>
            <h2 data-testid="contact-title" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Let's Discuss Your
              <br />
              Intelligence Needs
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Ready to enhance your security posture with professional OSINT and risk reporting? Contact us to discuss how we can support your organisation's intelligence requirements.
            </p>
          </div>

          {/* Right Column - Contact Tiles */}
          <div className="space-y-6">
            <ContactInfo
              icon={Mail}
              title="Email Us"
              value="scott.hardman@helixaspire.com.au"
              subtitle="We reply within 24 hours."
            />
            <ContactInfo
              icon={Phone}
              title="Call Us"
              value="+61 417 497 214 AEST"
              subtitle="7am to 11pm every day"
            />
          </div>
        </div>

        {/* Dashboard Preview Image */}
        <div className="mt-16">
          <img
            data-testid="dashboard-preview"
            src="https://customer-assets.emergentagent.com/job_site-clone-quiz/artifacts/9p9t9bk8_image.png"
            alt="HelixAspire Intelligence Dashboard and Reports"
            className="w-full rounded-xl shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
